export const episodes = [
  {
    id: "s1e1",
    season: 1,
    episodeNumber: 1,
    title: "归来的陌生人",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20lone%20woman%20with%20a%20suitcase%20arriving%20in%20a%20rainy%20small%20town%20at%20dusk%2C%20moody%20deep%20blue%20tones%20with%20amber%20street%20lights%2C%20misty%20atmosphere%2C%20widescreen%20drama&width=800&height=450&seq=ep-s1e1-v1&orientation=landscape",
    airDate: "2024-03-08",
    runtime: "52分钟",
    rating: 8.7,
    summary:
      "艾琳·卡特十年后重返北岸小镇，为哥哥的失踪寻找答案，却在旧宅门前遇见了不愿开口的大卫。",
    analysis:
      "本集用一场雨完成了整部剧的气质铺陈：潮湿、克制、处处留白。导演刻意不让任何人说完整的话，把信息藏在道具与沉默里——那封没有署名的信、仓库里落灰的工具箱、咖啡馆里忽然中断的对话，都是后续线索的伏笔。艾琳“回来”这个动作，本身就意味着有人不希望她回来。",
    cast: ["elena", "david", "karl"],
    tags: ["开篇", "家族谜局", "小镇悬疑"],
  },
  {
    id: "s1e2",
    season: 1,
    episodeNumber: 2,
    title: "尘封的信件",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20old%20yellowed%20letters%20scattered%20on%20a%20wooden%20desk%20under%20a%20warm%20lamp%2C%20moody%20dark%20blue%20shadows%20around%2C%20mysterious%20intimate%20drama%20atmosphere&width=800&height=450&seq=ep-s1e2-v1&orientation=landscape",
    airDate: "2024-03-15",
    runtime: "49分钟",
    rating: 8.5,
    summary:
      "莉娜从旧档案中还原出一段被删除的通话记录，艾琳则在一叠信件里认出了哥哥的笔迹。",
    analysis:
      "本集把“数据”与“手写信”并置，形成全剧一个重要的主题对照：冷的技术与热的情感，究竟谁更接近真相。莉娜的登场有效打破了单一视角的沉闷，也让调查从个人执念升级为一场团队行动。结尾处卡尔在码头欲言又止的镜头，是全季最耐人寻味的一次沉默。",
    cast: ["elena", "david", "lena", "karl"],
    tags: ["关键线索", "团队集结", "档案"],
  },
  {
    id: "s1e3",
    season: 1,
    episodeNumber: 3,
    title: "城郊之夜",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20an%20empty%20suburban%20street%20at%20night%20with%20a%20single%20car%20and%20cold%20blue%20light%2C%20lonely%20suspenseful%20mood%2C%20deep%20navy%20and%20amber%20highlights%20widescreen%20drama&width=800&height=450&seq=ep-s1e3-v1&orientation=landscape",
    airDate: "2024-03-22",
    runtime: "51分钟",
    rating: 8.9,
    summary:
      "一次深夜的城郊接头变成陷阱，艾琳第一次正面撞上斯特恩集团的影子，也第一次看见杰克。",
    analysis:
      "第三集是全季节奏的第一次提速。镜头调度从静态转为手持，配乐第一次出现明显的失真音色，暗示“秩序”开始崩塌。杰克这一角色的出场被处理为纯粹的压迫感——他不说威胁，却让整条街都安静下来。维多利亚全程没有露面，但她无处不在。",
    cast: ["elena", "david", "victoria", "jack", "karl"],
    tags: ["冲突升级", "反派登场", "动作场面"],
  },
  {
    id: "s1e4",
    season: 1,
    episodeNumber: 4,
    title: "沉默的证词",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20dim%20interrogation%20room%20with%20a%20lamp%20and%20two%20silhouettes%2C%20moody%20cold%20blue%20and%20warm%20amber%20contrast%2C%20tense%20quiet%20drama%20widescreen&width=800&height=450&seq=ep-s1e4-v1&orientation=landscape",
    airDate: "2024-03-29",
    runtime: "50分钟",
    rating: 8.6,
    summary:
      "警长马丁试图以“意外”结案，艾琳却在一次对峙中逼出了当年案卷被改写的关键时间点。",
    analysis:
      "本集几乎全部发生在室内，是一场典型的信息攻防战。编剧用“谁先眨眼”的博弈来塑造马丁这个灰色人物：他不是坏人，只是更害怕混乱。艾琳终于获得第一块确凿的时间拼图，也让“哥哥自行离开”的官方结论第一次出现裂缝。",
    cast: ["elena", "david", "martin", "jack"],
    tags: ["审讯", "灰色人物", "反转"],
  },
  {
    id: "s1e5",
    season: 1,
    episodeNumber: 5,
    title: "第一道裂痕",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20cracked%20frozen%20lake%20at%20dawn%20with%20a%20distant%20figure%2C%20moody%20pale%20blue%20and%20amber%20sunrise%2C%20melancholic%20drama%20widescreen&width=800&height=450&seq=ep-s1e5-v1&orientation=landscape",
    airDate: "2024-04-05",
    runtime: "55分钟",
    rating: 9.1,
    summary:
      "季终集，团队拼出的真相指向维多利亚，却也被对方反将一军；大卫终于说出他隐藏十年的那句话。",
    analysis:
      "季终把前面的所有留白一次性点燃。湖面开裂的意象贯穿全集，既指真相的松动，也指人物关系的决裂。大卫的坦白来得克制而沉重，是全季情感的最高点。维多利亚最后那句“你以为你在查案，其实你在选阵营”，为第二季埋下了最大的钩子。",
    cast: ["elena", "david", "lena", "victoria", "isabel"],
    tags: ["季终", "真相揭示", "高能"],
  },
  {
    id: "s2e1",
    season: 2,
    episodeNumber: 1,
    title: "旧日回响",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20an%20old%20archive%20room%20with%20tall%20shelves%20and%20dust%20in%20a%20beam%20of%20light%2C%20moody%20deep%20blue%20and%20amber%2C%20mysterious%20quiet%20drama%20widescreen&width=800&height=450&seq=ep-s2e1-v1&orientation=landscape",
    airDate: "2024-09-06",
    runtime: "53分钟",
    rating: 8.8,
    summary:
      "新一季开篇，档案室管理员诺亚交出一份被系统删除的旧案索引，调查从个人恩怨转向系统性掩盖。",
    analysis:
      "第二季主动把格局从“一桩失踪案”扩展为“一座小镇的集体记忆”。诺亚的加入带来了新的道德张力：他掌握真相，却也想独占真相。开篇用档案室的光影重建了第一季的压抑气质，同时暗示线索的层级已经不同。",
    cast: ["elena", "lena", "noah", "david"],
    tags: ["新季开篇", "档案", "格局升级"],
  },
  {
    id: "s2e2",
    season: 2,
    episodeNumber: 2,
    title: "双重身份",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20man%20looking%20at%20his%20own%20reflection%20in%20a%20dark%20window%2C%20moody%20split%20lighting%20blue%20and%20amber%2C%20psychological%20drama%20widescreen&width=800&height=450&seq=ep-s2e2-v1&orientation=landscape",
    airDate: "2024-09-13",
    runtime: "51分钟",
    rating: 8.7,
    summary:
      "大卫的过去被摊开在阳光下，他当年为何结案、又为何辞职，第一次有了完整的答案。",
    analysis:
      "本集是一集典型的“人物翻面”。编剧没有把大卫洗白，而是让他站在灰色地带继续前行。镜中对照的视觉母题贯穿全集，暗示每个人都在扮演两个自己——包括艾琳自己。马丁与大卫的旧日对话成为全集情感支点。",
    cast: ["david", "elena", "martin", "noah"],
    tags: ["身世揭秘", "人物弧光"],
  },
  {
    id: "s2e3",
    season: 2,
    episodeNumber: 3,
    title: "雨夜的交易",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20two%20figures%20exchanging%20a%20briefcase%20under%20heavy%20rain%20in%20an%20alley%2C%20cold%20blue%20and%20amber%20lamp%20light%2C%20tense%20noir%20drama%20widescreen&width=800&height=450&seq=ep-s2e3-v1&orientation=landscape",
    airDate: "2024-09-20",
    runtime: "50分钟",
    rating: 8.9,
    summary:
      "一场雨夜交易把卡尔推向风口浪尖，维多利亚借杰克之手清理痕迹，代价却落在最无辜的人身上。",
    analysis:
      "本集是全季最具类型片质感的一集，雨、伞、车灯构成一组经典的黑色电影视觉。编剧让卡尔的恐惧成为叙事发动机，也用他的崩溃反衬维多利亚那种“优雅地残忍”。杰克的犹豫第一次被镜头捕捉，为第三季的转向埋线。",
    cast: ["victoria", "jack", "karl", "david"],
    tags: ["黑色电影", "交易", "高张力"],
  },
  {
    id: "s2e4",
    season: 2,
    episodeNumber: 4,
    title: "被篡改的录像",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20glitchy%20security%20monitor%20screens%20in%20a%20dark%20control%20room%2C%20cold%20blue%20glow%20with%20amber%20accents%2C%20tech%20thriller%20mood%20widescreen&width=800&height=450&seq=ep-s2e4-v1&orientation=landscape",
    airDate: "2024-09-27",
    runtime: "52分钟",
    rating: 8.6,
    summary:
      "莉娜发现关键监控被人为覆盖，苏菲交出一份旧病历，两条看似无关的线索在时间上重合。",
    analysis:
      "这是全季最“技术流”的一集，但技术始终服务于情感。莉娜对数据的执着，与苏菲对沉默的克制形成对照，两人代表了面对真相的两种态度。监控画面的雪花噪点是本集的视觉隐喻：真相存在，只是被反复擦写。",
    cast: ["lena", "sophie", "noah", "jack"],
    tags: ["数据线索", "交叉叙事"],
  },
  {
    id: "s2e5",
    season: 2,
    episodeNumber: 5,
    title: "背叛的代价",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20tense%20standoff%20on%20a%20harbor%20dock%20at%20night%2C%20distant%20city%20lights%20reflecting%20on%20water%2C%20moody%20deep%20blue%20and%20amber%2C%20dramatic%20widescreen&width=800&height=450&seq=ep-s2e5-v1&orientation=landscape",
    airDate: "2024-10-04",
    runtime: "56分钟",
    rating: 9.2,
    summary:
      "季终集，团队内部的信任崩盘，诺亚的选择让调查几乎功亏一篑，而维多利亚第一次露出破绽。",
    analysis:
      "第二季以一个“自己人出事”的结局收束，把悬念从外部威胁转向内部裂痕。码头对峙的调度克制而漫长，几乎不给观众喘息。结尾资料袋被调包的一刻，是对第一季“第一道裂痕”的镜像回应——这一次，裂缝出现在他们之间。",
    cast: ["elena", "david", "lena", "noah", "victoria", "martin", "sophie"],
    tags: ["季终", "背叛", "高能"],
  },
  {
    id: "s3e1",
    season: 3,
    episodeNumber: 1,
    title: "新秩序",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20glass%20corporate%20boardroom%20at%20dusk%20overlooking%20a%20small%20town%2C%20cold%20blue%20and%20amber%20tones%2C%20power%20drama%20widescreen&width=800&height=450&seq=ep-s3e1-v1&orientation=landscape",
    airDate: "2025-03-07",
    runtime: "54分钟",
    rating: 8.9,
    summary:
      "第三季开篇，维多利亚重组权力版图，伊莎贝尔登场；大卫与杰克旧账被翻出，小镇进入新的博弈。",
    analysis:
      "本季把舞台从街道搬进会议室，用玻璃与冷光塑造“新秩序”的封闭感。伊莎贝尔的登场是全季最大的变量，她说话的方式与维多利亚如出一辙，却在细节处更急、更狠，暗示她并不满足于做影子。",
    cast: ["victoria", "isabel", "jack", "martin", "david"],
    tags: ["新季开篇", "权力博弈", "新角色"],
  },
  {
    id: "s3e2",
    season: 3,
    episodeNumber: 2,
    title: "失踪的三天",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20an%20empty%20motel%20room%20at%20night%20with%20a%20single%20lamp%20and%20an%20unmade%20bed%2C%20moody%20deep%20blue%20and%20amber%2C%20mysterious%20drama%20widescreen&width=800&height=450&seq=ep-s3e2-v1&orientation=landscape",
    airDate: "2025-03-14",
    runtime: "52分钟",
    rating: 8.8,
    summary:
      "艾琳与莉娜追查一段无人记得的三天空白，却发现档案、监控与证词在这个时间点全部被人为抹去。",
    analysis:
      "“三天空白”是本季的核心悬念，编剧用一间廉价旅馆房间来完成它的具象化：所有痕迹都被打扫干净，只留下一支没拧紧的口红。诺亚在本集开始偏离团队，他的偏执第一次显露出危险的一面。",
    cast: ["elena", "lena", "noah", "david"],
    tags: ["核心悬念", "解谜"],
  },
  {
    id: "s3e3",
    season: 3,
    episodeNumber: 3,
    title: "暗流",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20dark%20water%20surface%20with%20hidden%20submerged%20shapes%20and%20faint%20amber%20glow%2C%20abstract%20moody%20blue%20drama%20widescreen&width=800&height=450&seq=ep-s3e3-v1&orientation=landscape",
    airDate: "2025-03-21",
    runtime: "51分钟",
    rating: 8.7,
    summary:
      "伊莎贝尔与维多利亚的分歧公开化，苏菲提供的关键证词让整条权力链出现第一处松动。",
    analysis:
      "本集是全季的文戏高峰，几乎靠对话推动，却处处暗涌。伊莎贝尔与维多利亚的对手戏像一场下棋，每句客气话里都藏着刀。水面下的暗流意象把权力结构可视化——看不见的部分，才是决定流向的部分。",
    cast: ["victoria", "isabel", "sophie", "elena"],
    tags: ["文戏", "权力暗战"],
  },
  {
    id: "s3e4",
    season: 3,
    episodeNumber: 4,
    title: "镜中之影",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20long%20dark%20corridor%20lined%20with%20mirrors%20and%20a%20single%20figure%2C%20moody%20cold%20blue%20with%20amber%20rim%20light%2C%20psychological%20thriller%20widescreen&width=800&height=450&seq=ep-s3e4-v1&orientation=landscape",
    airDate: "2025-03-28",
    runtime: "53分钟",
    rating: 9.0,
    summary:
      "大卫与杰克在废弃仓库正面交锋，两段旧日恩怨被同时摊开；卡尔的证词成为压垮天平的最后一根稻草。",
    analysis:
      "本集是全季动作与情感的双重高潮，但打斗被刻意压低音量，取而代之的是两个中年男人跨越十年的对话。镜廊的视觉设计让“每个人都活在自己的倒影里”这一主题落到实处。卡尔终于开口，代价是他此前所有沉默的清算。",
    cast: ["david", "jack", "karl", "martin"],
    tags: ["对决", "旧账清算", "高能"],
  },
  {
    id: "s3e5",
    season: 3,
    episodeNumber: 5,
    title: "真相的边界",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20blinding%20bright%20doorway%20at%20the%20end%20of%20a%20dark%20room%20with%20a%20silhouette%2C%20moody%20deep%20blue%20with%20warm%20amber%20glow%2C%20symbolic%20drama%20widescreen&width=800&height=450&seq=ep-s3e5-v1&orientation=landscape",
    airDate: "2025-04-04",
    runtime: "57分钟",
    rating: 9.3,
    summary:
      "季终，团队拿到了足以翻案的材料，诺亚却在最后关头做出不可挽回的选择，真相反过来反噬了他们。",
    analysis:
      "第三季季终把主题推到最尖锐处：真相本身没有边界，只有持有真相的人有边界。诺亚的抉择令人痛心却逻辑自洽，他从“记录者”变成了“审判者”。结尾那扇突然亮起的门，是全剧最富象征意味的一个镜头——走出去的不一定是自由。",
    cast: ["elena", "lena", "noah", "victoria", "isabel", "sophie"],
    tags: ["季终", "悲剧转折", "高能"],
  },
  {
    id: "s4e1",
    season: 4,
    episodeNumber: 1,
    title: "最后一封信",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20single%20sealed%20letter%20on%20a%20windowsill%20with%20rain%20on%20glass%2C%20moody%20deep%20blue%20with%20amber%20interior%20light%2C%20melancholic%20drama%20widescreen&width=800&height=450&seq=ep-s4e1-v1&orientation=landscape",
    airDate: "2025-09-05",
    runtime: "55分钟",
    rating: 9.0,
    summary:
      "最终季开篇，一封迟到十年的信揭开哥哥失踪的完整动机，艾琳第一次怀疑自己查的方向从一开始就错了。",
    analysis:
      "终季没有继续堆悬念，而是选择“倒放”——把已知拼图重新排列。开场那封信的处理极度克制，几乎不给煽情空间，反而是这种冷更让人心碎。艾琳的自我怀疑成为全季的情感主轴，也让她的角色弧光得以收束。",
    cast: ["elena", "david", "noah", "lena"],
    tags: ["最终季", "情感核心"],
  },
  {
    id: "s4e2",
    season: 4,
    episodeNumber: 2,
    title: "猎人与猎物",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20foggy%20forest%20at%20night%20with%20a%20torch%20beam%20cutting%20through%20trees%2C%20cold%20blue%20and%20amber%20glow%2C%20tense%20manhunt%20drama%20widescreen&width=800&height=450&seq=ep-s4e2-v1&orientation=landscape",
    airDate: "2025-09-12",
    runtime: "52分钟",
    rating: 8.9,
    summary:
      "伊莎贝尔与维多利亚彻底撕破脸，杰克站到了十字路口；小镇在一夜之间失去了表面的平静。",
    analysis:
      "本集用一场雾夜追捕完成权力的最后交接。猎人与猎物的身份不断交换，是全季结构上最精巧的一集。伊莎贝尔的手段比维多利亚更不留余地，也正因如此，她正在重复她最想推翻的那个人。",
    cast: ["isabel", "victoria", "jack", "david", "karl"],
    tags: ["权力更迭", "追捕", "高能"],
  },
  {
    id: "s4e3",
    season: 4,
    episodeNumber: 3,
    title: "家族的秘密",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20an%20old%20family%20mansion%20hallway%20with%20framed%20portraits%20and%20a%20dim%20chandelier%2C%20moody%20deep%20blue%20and%20amber%2C%20gothic%20drama%20widescreen&width=800&height=450&seq=ep-s4e3-v1&orientation=landscape",
    airDate: "2025-09-19",
    runtime: "54分钟",
    rating: 9.1,
    summary:
      "卡特家老宅被重新打开，两代人共同的秘密浮出水面，艾琳终于明白哥哥当年为何选择离开。",
    analysis:
      "本集是全剧信息量最大的一集，用一座老宅的走廊把历史与当下缝合。那些墙上的旧照片不是装饰，而是无声的证词。苏菲与诺亚各自的选择在这里收束，一个选择了站出来，一个选择了离开。",
    cast: ["elena", "sophie", "noah", "david"],
    tags: ["真相核心", "家族史"],
  },
  {
    id: "s4e4",
    season: 4,
    episodeNumber: 4,
    title: "崩溃边缘",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20near%20empty%20hospital%20corridor%20at%20night%20with%20flickering%20lights%2C%20cold%20blue%20and%20warm%20amber%20spill%2C%20emotional%20drama%20widescreen&width=800&height=450&seq=ep-s4e4-v1&orientation=landscape",
    airDate: "2025-09-26",
    runtime: "53分钟",
    rating: 9.2,
    summary:
      "一次意外把艾琳推到医院，团队在失去主心骨后被迫各自面对选择；大卫说出最后一段没说完的过去。",
    analysis:
      "本集把节奏按到最低，几乎全部在医院空间完成，用安静制造最大的情绪压力。艾琳的“缺席”反而让每个角色完成了自我审视。大卫的独白是全剧最克制也最沉重的一场戏，他没有请求原谅，只是把话说完了。",
    cast: ["elena", "david", "lena", "sophie", "jack"],
    tags: ["情感高峰", "文戏"],
  },
  {
    id: "s4e5",
    season: 4,
    episodeNumber: 5,
    title: "终局",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20town%20square%20at%20dawn%20with%20long%20shadows%20and%20a%20clearing%20sky%2C%20moody%20deep%20blue%20fading%20into%20warm%20amber%20dawn%2C%20epic%20finale%20drama%20widescreen&width=800&height=450&seq=ep-s4e5-v1&orientation=landscape",
    airDate: "2025-10-03",
    runtime: "62分钟",
    rating: 9.5,
    summary:
      "全剧大结局：真相被公开，但代价是所有人都失去了一部分自己；艾琳在旧宅门口做出了最后的决定。",
    analysis:
      "大结局放弃了“正义胜利”的爽感，选择了更诚实的代价叙事。黎明广场的长镜头是对全剧开篇雨夜的一次精确回应：同样的地方，不同的光。片尾没有给出廉价的团圆，而是把选择权交还给了艾琳，也交还给了观众。",
    cast: ["elena", "david", "lena", "victoria", "isabel", "jack", "sophie", "noah"],
    tags: ["大结局", "全剧高潮", "必看"],
  },
];